import React from "react";
import styled from "styled-components";
import { bool, func, number } from "prop-types";
import { postcodeCtaClick } from "data/segmentCustomEvents";
import Button from "components/shared/Button";
import Copy from "components/shared/Copy";

const CTAContainer = styled.div`
  position: fixed;
  padding: 1rem;
  bottom: 0;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  background: ${({ theme }) => theme.colors.darkBlue};
  border-radius: 10px 10px 0 0;
  color: white;
  animation: float-in 1s forwards;
  animation: ${({ hidden }) => hidden && "float-out 1s forwards"};
  z-index: 1;
  width: 100vw;

  @media (min-width: ${({ theme }) => theme.screen.tablet}px) {
    width: 500px;
    left: calc(50% - 250px);
    &:hover {
      transform: scale(1.01);
    }
  }

  @keyframes float-in {
    from {
      transform: translateY(100vh);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes float-out {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(100vh);
    }
  }
`;

const ButtonContainer = styled.div`
  flex-basis: 33%;
  min-width: 33%;
  text-align: center;
`;

const TextContainer = styled.div`
  flex-basis: 66%;
  min-width: 66%;
`;

const OnboardingCTA = ({
  isFormOpen,
  isMobile,
  toggleFormOpenState
}) => {
  const triggerEventAndOpenForm = () => {
    postcodeCtaClick();
    toggleFormOpenState(true);
  };

  return (
    <CTAContainer onClick={triggerEventAndOpenForm} hidden={isFormOpen}>
      <TextContainer>
        <Copy size={isMobile ? 1 : 1.1} weight="600">
          Continue your search
        </Copy>
      </TextContainer>
      <ButtonContainer>
        <Button
          background="red"
          label="Find care"
          size={isMobile ? "0.7rem" : "1rem"}
          width={!isMobile ? "125px" : null}
        />
      </ButtonContainer>
    </CTAContainer>
  );
};

OnboardingCTA.propTypes = {
  isFormOpen: bool.isRequired,
  isMobile: bool.isRequired,
  toggleFormOpenState: func.isRequired,
  useVariant: number
};

export default OnboardingCTA;
